import { createContext, useContext, useEffect, useState, type ReactNode } from "react"
import { getMe, setOn401, type Me } from "./api"

type AuthState =
  | { status: "loading" }
  | { status: "authed"; me: Me; refresh: () => Promise<void> }
  | { status: "anon" }

const AuthContext = createContext<AuthState>({ status: "loading" })

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({ status: "loading" })

  const load = async () => {
    try {
      const me = await getMe()
      setState({
        status: "authed",
        me,
        refresh: async () => {
          const m = await getMe()
          setState((s) => (s.status === "authed" ? { ...s, me: m } : s))
        },
      })
    } catch {
      setState({ status: "anon" })
    }
  }

  useEffect(() => {
    setOn401(() => setState({ status: "anon" }))
    void load()
  }, [])

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>
}

export function useAuth() {
  return useContext(AuthContext)
}
